import { render, staticRenderFns } from "./CodeBar.vue?vue&type=template&id=48a02011&"
import script from "./CodeBar.vue?vue&type=script&lang=ts&"
export * from "./CodeBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports